module.exports = __webpack_public_path__ + "img/drives.8866b1a3.webp";